// extracted by mini-css-extract-plugin
module.exports = {"alert":"StoreLocale_alert__zjRMe","buttons":"StoreLocale_buttons__Ombbk","leftToRight":"StoreLocale_leftToRight__3MLd2"};